import { NotifyError } from "./ShowError";
import General from "../stores/GeneralStore";

function validateEID(value) {
    if(!value){
     NotifyError(General?.codeLabels['cm_mob_eidrqrd']?.label)
     return;
    }
     // regex for emirates id with birth dates between 1900 and 2099
     var re = new RegExp(/784[-]*(19|20)\d{2}[-]*\d{7}[-]*\d/);
     var eid = value;
     if (!re.test(eid)) {
       NotifyError(General?.codeLabels["cm_emirate_req"]?.label?General?.codeLabels["cm_emirate_req"]?.label:"Emirates ID not valid")
       return false;
     }
     // luhn algorithm for checkdigit
     var s = 0,
         x = true;
     var v = eid.replace(/\D/g, "");
     var len = v.length;
     var checkdigit = v.charAt(len-1);
     for (var n = len-2; n >= 0; n--) {
       var c = v.charAt(n),
           i = parseInt(c, 10);
       if (x && (i *= 2) > 9) i -= 9;
       s += i;
       x = !x;
     }
     var checksum = (s * 9) % 10;
     // validate checkdigit
     if (checksum != checkdigit) {
       NotifyError(General?.codeLabels["cm_emirate_req"]?.label?General?.codeLabels["cm_emirate_req"]?.label:"Emirates ID not valid")
       return false;
     }
    
     return true;
   }
   export default validateEID;